import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=a18fb868&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=js&"
export * from "./uploader.vue?vue&type=script&lang=js&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=a18fb868&lang=less&scoped=true&"
import style1 from "./uploader.vue?vue&type=style&index=1&id=a18fb868&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18fb868",
  null
  
)

export default component.exports